export default __webpack_public_path__ + "static/media/password-error.347deab4.svg";